module.exports = __webpack_public_path__ + "static/media/uploadSuccess.26eddcab.svg";